const faqs = [
  {
    title: "Can I have two phone numbers on one phone?",
    id: 1,
    isShow: false,
    content: `Absolutely you can!<br/>Dingtone allows you to have two or multiple phone numbers on one cell phone. Certain qualified users can also get a second phone number from Dingtone app for free to use it for specific purpose such as business, dating, etc.`,
  },
  {
    title: "How to get a second phone number?",
    id: 2,
    isShow: false,
    content: `Use Dingtone app on your cell phone or tablet and you'll be able to get a second phone number. The second phone number can be used to make unlimited internet phone calls and texts.`,
  },
  {
    title: "How to hide my phone number when texting?",
    id: 3,
    isShow: false,
    content: `Get an extra phone number from Dingtone to text and your private phone number will be well hidden. Dingtone is an app providing online calling and texting.`,
  },
  {
    title: "How much do international calls cost?",
    id: 4,
    isShow: false,
    content: `Generally speaking, international calls cost a lot. When Dingtone is used for international calling to any phone and texting, the international calling rates will be extremely low because an online service is used with VOIP technology applied.`,
  },
  {
    title: "Can I keep my phone number forever?",
    id: 6,
    isShow: false,
    content: `No.<br/>
      Dingtone phone numbers are the property of Dingtone, Inc. We lease them to you with certain conditions and we reserve the right to revoke your number if those conditions aren't met.<br/>
      Dingtone phone numbers are expensive and limited so we assign them to serious users only.<br/>
      You must use your Dingtone phone number at least once per month to keep it active. It doesn’t matter how you use it – make/receive calls or send/receive texts – as long as you use it.<br/>
      Inactive free phone numbers will be reassigned to other Dingtone users without notification or refund.`,
  },
  {
    title: "Is Dingtone safe?",
    id: 8,
    isShow: false,
    content: `Absolutely yes. Dingtone doesn't access your personal information or contacts unless you allow it to do that. Moreover, the second phone number Dingtone provides can protect your private number from being exposed to the Internet and online accounts by separating your private number from other numbers for business.`,
  },
  {
    title: "How does Dingtone work?",
    id: 9,
    isShow: false,
    content: `Dingtone allows its users to call and text from Internet to any phone, mobile or landline based on VoIP technology No matter where you are, as long as there's access to the Internet or cellular data, Dingtone can be used for calls and texts. Users are also allowed to get a real number with a country code they like from Dingtone and are able to make unlimited calls and texts to any number all over the world. Dingtone allows its users to call and text totally for free based on Dingtone credits that can be earned from the App.`,
  },
  {
    title: "How to delete Dingtone account?",
    id: 10,
    isShow: false,
    content: `You can take the following steps to stop Dingtone working on your device.<br/>
      Tap the "More" > "Settings" > "Account Settings" > "My Devices on Dingtone". You can either tap "Deactivate the current device" or delete another device with your Dingtone account on the window. As a result, your Dingtone account will be stopped.`,
  },
  {
    title: "Can Dingtone number be used for WhatsApp?",
    id: 11,
    isShow: false,
    content: `Dingtone phone number is not tied to a physical SIM card, therefore, it may not be accepted for registration on some Apps/ websites. We do not guarantee that it would receive code from all websites and apps.`,
  },
  {
    title: "How to change my number on Dingtone?",
    id: 12,
    isShow: false,
    content: `We're sorry to tell you that you aren't allowed to change your number on Dingtone but there's a solution to that. You can select and pay for another Dingtone number and keep it yours. If your previous phone number goes overdue, it won't be able to be used on Dingtone. Then, your current Dingtone number will be your new one.`,
  },
  {
    title: "Will Dingtone calls show up on bill?",
    id: 13,
    isShow: false,
    content: `All the calls and texts in Dingtone don’t cost any of your cell minutes or texts, but Dingtone credits instead. Therefore, Dingtone calls won't show up on your calling bill. 
      You can get Dingtone credits by completing easy tasks in the app or just purchase credits with an affordable price 10%-20% lower than what phone operators offer. It can save over 80% off your phone bill!`,
  },
];
module.exports.getFaqList = () => {
  return faqs;
};
